import { render, staticRenderFns } from "./FinishAluminum.vue?vue&type=template&id=ef238e6c&"
import script from "./FinishAluminum.vue?vue&type=script&lang=js&"
export * from "./FinishAluminum.vue?vue&type=script&lang=js&"
import style0 from "./FinishAluminum.vue?vue&type=style&index=0&id=ef238e6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports